<img
  [style.width]="width"
  [style.height]="height"
  alt="image"
  [src]="imageSource" />
<pcs-icon
  icon="close"
  size="iconXL"
  (click)="lightboxService.close()"></pcs-icon>
